var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: Boolean(_vm.action),
              expression: "Boolean(action)"
            }
          ],
          ref: "cargoLeftRightResize",
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": { flex: "none", "max-width": "190px" },
            "right-style": { overflow: "hidden" },
            "show-left":
              _vm.action === "look" ||
              (_vm.isEditing &&
                _vm.activeTabName === "tabCharges" &&
                _vm.basicInfoVisible)
          }
        },
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c("cargo-ag-grid", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.action === "look",
                    expression: "action==='look'"
                  }
                ],
                staticClass: "section",
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "row-data": _vm.rowData,
                  "show-side-bar": false,
                  "check-sub-record": false,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "deselect-sub-record": false,
                  "min-height": "100%",
                  "grid-style": "min-width: 220px;width:100%;height:100%;"
                },
                on: { gridReady: _vm.onGridReady }
              }),
              _vm.isEditing &&
              _vm.activeTabName === "tabCharges" &&
              _vm.basicInfoVisible
                ? _c("cargo-ag-grid", {
                    staticClass: "section",
                    attrs: {
                      "grid-options": _vm.basicInfo.gridOptions,
                      "row-data": _vm.basicInfo.rowData,
                      "show-side-bar": false,
                      "check-sub-record": false,
                      "check-main-record": false,
                      "deselect-main-record": false,
                      "deselect-sub-record": false,
                      "min-height": "100%",
                      "grid-style": "min-width: 220px;width:100%;height:100%;"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "5px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers" },
                    [
                      _c(
                        "cargo-button-group-slider",
                        { ref: "cargoButtonGroupSlider" },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.action === "look",
                                  expression: "action==='look'"
                                }
                              ],
                              class:
                                "btn-group-look" +
                                (_vm.canOperateJob ? "" : " cannot-operate-job")
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "can-operate",
                                  attrs: { no: "back", type: "primary" },
                                  on: { click: _vm.goBack }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
                              ),
                              _vm.canEditByPermission
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "edit",
                                        disabled: !(
                                          _vm.job &&
                                          Number(_vm.job.jobState) === 0 &&
                                          !_vm.JobUtils.isBlockJob(_vm.job)
                                        ),
                                        type: "success"
                                      },
                                      on: { click: _vm.triggerEditEvent }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                                  )
                                : _vm._e(),
                              _vm.source === "endCommerce"
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { no: "return", type: "warning" },
                                      on: { click: _vm.toOpenReturnDialog }
                                    },
                                    [_vm._v("退回")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.action === "edit",
                                  expression: "action==='edit'"
                                }
                              ],
                              staticClass: "btn-group-edit",
                              staticStyle: {
                                "border-left": "none",
                                "padding-left": "0"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "save",
                                    type: "success",
                                    disabled: !_vm.canSave || _vm.isLoadingData
                                  },
                                  on: { click: _vm.triggerSaveEvent }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "cancel",
                                    type: "success",
                                    disabled: !_vm.canSave
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.cancelEdit(
                                        _vm.openMultiple
                                          ? _vm.againLookAtMultiple
                                          : function() {
                                              _vm.againShow("look")
                                            }
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "SaveTheDefaultValues",
                                    type: "primary"
                                  },
                                  on: { click: _vm.saveDefaultVal }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.SaveTheDefaultValues")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isNew,
                                  expression: "isNew"
                                }
                              ],
                              staticClass: "new btn-group-new",
                              staticStyle: {
                                "border-left": "none",
                                "padding-left": "0"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "save2",
                                    type: "success",
                                    disabled: !_vm.canSave || _vm.isLoadingData
                                  },
                                  on: { click: _vm.triggerSaveEvent }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "cancel2",
                                    type: "success",
                                    disabled: !_vm.canSave
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.cancelEdit(
                                        _vm.openMultiple
                                          ? _vm.goBackAtMultiple
                                          : _vm.goBack
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "SaveTheDefaultValues2",
                                    type: "primary"
                                  },
                                  on: { click: _vm.saveDefaultVal }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.SaveTheDefaultValues")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.action === "look" || _vm.action === "edit",
                              expression: "action==='look'||action==='edit'"
                            }
                          ],
                          staticStyle: {
                            display: "flex",
                            "white-space": "nowrap"
                          }
                        },
                        [
                          _c("CargoIm", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.imCacheKey && _vm.action === "look",
                                expression: "imCacheKey && action==='look'"
                              }
                            ],
                            ref: "cargoIm"
                          }),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content:
                                  _vm.action === "edit"
                                    ? ""
                                    : _vm.$t("SeaExport.Tip1"),
                                placement: "bottom-start",
                                offset: _vm.sopTooltipOffset,
                                "visible-arrow": false
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "right-tip",
                                  on: {
                                    mousemove: _vm.resetSopTooltip,
                                    dblclick: function($event) {
                                      return _vm.onBtnListDoubleClicked()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "red",
                                      staticStyle: { "font-size": "14px" },
                                      attrs: { no: "SopState" }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.commonInfo.jobState) +
                                          " "
                                      ),
                                      (_vm.job.jobState === 0 ||
                                        _vm.job.jobState === 1 ||
                                        _vm.job.jobState === 2 ||
                                        _vm.job.jobState === 11) &&
                                      _vm.job.shutOut &&
                                      !_vm.commonInfo.jobChangeState
                                        ? _c(
                                            "font",
                                            {
                                              staticClass: "red",
                                              staticStyle: {
                                                "font-size": "14px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Message.HasChargeToShutOut"
                                                    )
                                                  ) +
                                                  ")"
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      (_vm.job.jobState === 0 ||
                                        _vm.job.jobState === 1 ||
                                        _vm.job.jobState === 2 ||
                                        _vm.job.jobState === 11) &&
                                      _vm.job.shutOut &&
                                      _vm.commonInfo.jobChangeState
                                        ? _c(
                                            "font",
                                            {
                                              staticClass: "red",
                                              staticStyle: {
                                                "font-size": "14px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Message.HasChargeToShutOut"
                                                    )
                                                  ) +
                                                  "/" +
                                                  _vm._s(
                                                    _vm.commonInfo
                                                      .jobChangeState
                                                  ) +
                                                  ")"
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      !(
                                        (_vm.job.jobState === 0 ||
                                          _vm.job.jobState === 1 ||
                                          _vm.job.jobState === 2 ||
                                          _vm.job.jobState === 11) &&
                                        _vm.job.shutOut
                                      ) && _vm.commonInfo.jobChangeState
                                        ? _c(
                                            "font",
                                            {
                                              staticClass: "red",
                                              staticStyle: {
                                                "font-size": "14px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    _vm.commonInfo
                                                      .jobChangeState
                                                  ) +
                                                  ")"
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.job.payableChargeLockedStatus === 1
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "red",
                                              staticStyle: {
                                                margin: "0px 0px 0px 0px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_PayableLockedStatusTag"
                                                  )
                                                )
                                              ),
                                              _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "dark",
                                                    content:
                                                      _vm.payableChargeLockedTooltip,
                                                    placement: "bottom",
                                                    "visible-arrow": false
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-warning",
                                                    staticStyle: {
                                                      cursor: "pointer"
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  [
                                    _vm.action === "edit" &&
                                    _vm.activeTabName === "tabCharges"
                                      ? _c("span", {
                                          staticStyle: { color: "unset" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.commonInfo.chargeJobTitle
                                            )
                                          }
                                        })
                                      : _c("span", {
                                          staticStyle: { color: "unset" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.commonInfo.jobTitle
                                            )
                                          }
                                        })
                                  ],
                                  _c("span", { staticClass: "red" }, [
                                    _vm._v(_vm._s(_vm.commonInfo.jobLock))
                                  ]),
                                  _vm.commonInfo.provisionLock &&
                                  _vm.commonInfo.provisionLock.etdLocked
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "14px",
                                            color: "red",
                                            "margin-left": "10px"
                                          }
                                        },
                                        [_vm._v("计提已校准")]
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          ),
                          _vm.job.zyCreditWarning
                            ? _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.job.zyCreditWarning,
                                    placement: "bottom-start",
                                    "visible-arrow": false
                                  }
                                },
                                [
                                  _c("div", { staticClass: "right-tip" }, [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          color: "orange",
                                          width: "220px",
                                          overflow: "hidden",
                                          "text-overflow": "ellipsis",
                                          "white-space": "nowrap"
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.job.zyCreditWarning))]
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isNew && _vm.activeTabName === "tabCharges",
                            expression: "isNew&&activeTabName==='tabCharges'"
                          }
                        ],
                        domProps: {
                          innerHTML: _vm._s(_vm.commonInfo.chargeJobTitle)
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  ref: "tabsContainer",
                  class:
                    "tabs-container" +
                    (_vm.canOperateJob ? "" : " cannot-operate-job"),
                  staticStyle: { position: "relative" }
                },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "tabs",
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "card",
                        "before-leave": function(activeName, oldActiveName) {
                          _vm.beforeLeaveTab(activeName, oldActiveName)
                        }
                      },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      !_vm.masterFlag &&
                      (_vm.privilege.seBooking.bookingTab || _vm.isVerify)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 1,
                              attrs: {
                                lazy: true,
                                name: "tabBookingFCL",
                                label: _vm.$t("SeaExport.Basic")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable && !_vm.isFba
                                ? _c("tab-booking-FCLUICustom", {
                                    ref: "tabBookingFCL",
                                    attrs: {
                                      "is-fba": _vm.isFba,
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "processing-promise-list":
                                        _vm.processingPromiseList,
                                      "slave-customs-declaration-enable":
                                        _vm.slaveCustomsDeclarationEnable,
                                      "template-name": _vm.templateName,
                                      "provision-lock":
                                        _vm.commonInfo.provisionLock
                                    },
                                    on: {
                                      showYdBookingResult:
                                        _vm.showYdBookingResultHandler,
                                      updateJob: _vm.updateJob,
                                      showMscSupplement: function(p) {
                                        return _vm.showMscSupplementHandler(p)
                                      }
                                    }
                                  })
                                : _c("tab-booking-fcl", {
                                    ref: "tabBookingFCL",
                                    attrs: {
                                      "is-fba": _vm.isFba,
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "processing-promise-list":
                                        _vm.processingPromiseList,
                                      "slave-customs-declaration-enable":
                                        _vm.slaveCustomsDeclarationEnable,
                                      "provision-lock":
                                        _vm.commonInfo.provisionLock,
                                      "template-name": _vm.templateName
                                    },
                                    on: {
                                      showYdBookingResult:
                                        _vm.showYdBookingResultHandler,
                                      updateJob: _vm.updateJob,
                                      showMscSupplement: function(p) {
                                        return _vm.showMscSupplementHandler(p)
                                      }
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.masterFlag &&
                      (_vm.privilege.seBooking.bookingTab || _vm.isVerify) &&
                      !_vm.isBuyerConsoleFcl
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 2,
                              attrs: {
                                lazy: true,
                                name: "tabBookingMaster",
                                label: _vm.$t("SeaExport.Basic")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable && !_vm.isFba
                                ? _c("tab-booking-master-UICustom", {
                                    ref: "tabBookingMaster",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "is-fba": _vm.isFba,
                                      "is-sea-export": true,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "view-source": "bookingWorkspace",
                                      "processing-promise-list":
                                        _vm.processingPromiseList,
                                      "template-name": _vm.templateName
                                    },
                                    on: {
                                      addLcl: _vm.addBatchLcl,
                                      selectJob: function(jobUuid) {
                                        _vm.transferTargetRow("edit", jobUuid)
                                      },
                                      addSlavedJob: _vm.addSlavedJob,
                                      removeJobFromMaster:
                                        _vm.removeJobFromMaster,
                                      removeJob: _vm.removeJob,
                                      containerLoadTypeChange:
                                        _vm.containerLoadTypeChange,
                                      verticalScroll: _vm.onVerticalScroll
                                    }
                                  })
                                : _c("tab-booking-master", {
                                    ref: "tabBookingMaster",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "is-fba": _vm.isFba,
                                      "is-sea-export": true,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "view-source": "bookingWorkspace",
                                      "processing-promise-list":
                                        _vm.processingPromiseList,
                                      "template-name": _vm.templateName
                                    },
                                    on: {
                                      addLcl: _vm.addBatchLcl,
                                      selectJob: function(jobUuid) {
                                        _vm.transferTargetRow("edit", jobUuid)
                                      },
                                      addSlavedJob: _vm.addSlavedJob,
                                      removeJobFromMaster:
                                        _vm.removeJobFromMaster,
                                      removeJob: _vm.removeJob,
                                      containerLoadTypeChange:
                                        _vm.containerLoadTypeChange,
                                      verticalScroll: _vm.onVerticalScroll
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.masterFlag &&
                      (_vm.privilege.seBooking.bookingTab || _vm.isVerify) &&
                      _vm.isBuyerConsoleFcl
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 30,
                              attrs: {
                                lazy: true,
                                name: "tabBuyerConsoleFclBookingMaster",
                                label: _vm.$t("SeaExport.Basic")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable && !_vm.isFba
                                ? _c(
                                    "tab-buyer-console-fcl-booking-master-UICustom",
                                    {
                                      ref: "tabBuyerConsoleFclBookingMaster",
                                      attrs: {
                                        context: _vm.context,
                                        action: _vm.action,
                                        "is-sea-export": true,
                                        "cooperate-edit":
                                          _vm.cooperateEditOther,
                                        "view-source": "bookingWorkspace",
                                        "processing-promise-list":
                                          _vm.processingPromiseList,
                                        "template-name": _vm.templateName
                                      },
                                      on: {
                                        addLcl: _vm.addBatchLcl,
                                        selectJob: function(jobUuid) {
                                          _vm.transferTargetRow("edit", jobUuid)
                                        },
                                        addSlavedJob: _vm.addSlavedJob,
                                        removeJobFromMaster:
                                          _vm.removeJobFromMaster,
                                        removeJob: _vm.removeJob,
                                        containerLoadTypeChange:
                                          _vm.containerLoadTypeChange,
                                        updateJob: _vm.updateJob,
                                        verticalScroll: _vm.onVerticalScroll
                                      }
                                    }
                                  )
                                : _c("tab-buyer-console-fcl-booking-master", {
                                    ref: "tabBuyerConsoleFclBookingMaster",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "is-sea-export": true,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "view-source": "bookingWorkspace",
                                      "processing-promise-list":
                                        _vm.processingPromiseList,
                                      "template-name": _vm.templateName
                                    },
                                    on: {
                                      addLcl: _vm.addBatchLcl,
                                      selectJob: function(jobUuid) {
                                        _vm.transferTargetRow("edit", jobUuid)
                                      },
                                      addSlavedJob: _vm.addSlavedJob,
                                      removeJobFromMaster:
                                        _vm.removeJobFromMaster,
                                      removeJob: _vm.removeJob,
                                      containerLoadTypeChange:
                                        _vm.containerLoadTypeChange,
                                      updateJob: _vm.updateJob,
                                      verticalScroll: _vm.onVerticalScroll
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      (_vm.privilege.seBooking.vesselEqTab ||
                        _vm.privilege.salesQueryModule.vesselEqTab ||
                        _vm.isVerify)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 3,
                              attrs: {
                                lazy: true,
                                name: "tabVesselEq",
                                label: _vm.$t("SeaExport.Booking")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable && !_vm.isFba
                                ? _c("tab-vessel-eq-UICustom", {
                                    ref: "tabVesselEq",
                                    attrs: {
                                      "slave-customs-declaration-enable":
                                        _vm.slaveCustomsDeclarationEnable,
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit":
                                        _vm.cooperateEditBooking,
                                      "view-source": "bookingWorkspace",
                                      "do-saving": _vm.doSaving
                                    },
                                    on: {
                                      ediChangeHandler: function($event) {
                                        _vm.saveEventFlag = true
                                      },
                                      showYdBookingResult:
                                        _vm.showYdBookingResultHandler,
                                      reload: _vm.reload
                                    }
                                  })
                                : _c("tab-vessel-eq", {
                                    ref: "tabVesselEq",
                                    attrs: {
                                      "slave-customs-declaration-enable":
                                        _vm.slaveCustomsDeclarationEnable,
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit":
                                        _vm.cooperateEditBooking,
                                      "view-source": "bookingWorkspace",
                                      "do-saving": _vm.doSaving
                                    },
                                    on: {
                                      ediChangeHandler: function($event) {
                                        _vm.saveEventFlag = true
                                      },
                                      showYdBookingResult:
                                        _vm.showYdBookingResultHandler,
                                      reload: _vm.reload
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showMscSupplement
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "tabMscBooking",
                              attrs: {
                                lazy: true,
                                name: "tabMscBooking",
                                label: _vm.$t("CargoMsg.Cargo_MscBookingInfo")
                              }
                            },
                            [
                              _c("tab-msc-booking-info", {
                                ref: "tabMscBooking",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "param-data": _vm.changeDataSFT
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.tabInfo.visible.dataTrackingDisplay
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "tabDataTracking",
                              attrs: {
                                lazy: true,
                                name: "tabDataTracking",
                                label: _vm.$t("SeaExport.DataTracking")
                              }
                            },
                            [
                              _c("tab-data-tracking", {
                                ref: "tabDataTracking",
                                attrs: {
                                  context: _vm.context,
                                  job: _vm.job,
                                  action: _vm.action
                                },
                                on: {
                                  "update:job": function($event) {
                                    _vm.job = $event
                                  },
                                  toPacking: _vm.toPacking
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.masterFlag && _vm.paramsOfTab.usCustomsClearance
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "tabUsCustomsClearance",
                              attrs: {
                                lazy: true,
                                name: "tabUsCustomsClearance",
                                label: _vm.$t("queryJob.UsCustomsClearance")
                              }
                            },
                            [
                              _c("tab-us-customs-clearance", {
                                ref: "tabUsCustomsClearance",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "show-sync":
                                    _vm.btnInfo.btnEntrustmentSISynchronized,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.masterFlag && _vm.paramsOfTab.usCustomsClearance
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "tabUsCustomsClearanceMaster",
                              attrs: {
                                lazy: true,
                                name: "tabUsCustomsClearanceMaster",
                                label: _vm.$t("queryJob.UsCustomsClearance")
                              }
                            },
                            [
                              _c("tab-us-customs-clearance-master", {
                                ref: "tabUsCustomsClearanceMaster",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "show-sync":
                                    _vm.btnInfo.btnEntrustmentSISynchronized,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.masterFlag &&
                      (_vm.privilege.seBooking.prePlanBooking || _vm.isVerify)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 4,
                              attrs: {
                                lazy: true,
                                name: "tabPrePlanBooking",
                                label: _vm.$t("SeaExport.prePlanBooking")
                              }
                            },
                            [
                              _vm.commonInfo.showCombinedManifest
                                ? _c("tab-pre-plan-booking-jc", {
                                    ref: "tabPrePlanBooking",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: {
                                      syncData: _vm.syncData,
                                      reload: _vm.reload,
                                      prePlanBookingToVgm:
                                        _vm.prePlanBookingToVgm,
                                      jobChangeState: _vm.onJobChangeState
                                    }
                                  })
                                : _c("tab-pre-plan-booking", {
                                    ref: "tabPrePlanBooking",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: {
                                      syncData: _vm.syncData,
                                      reload: _vm.reload,
                                      prePlanBookingToVgm:
                                        _vm.prePlanBookingToVgm
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.masterFlag &&
                      (_vm.privilege.seBooking.prePlanBooking || _vm.isVerify)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 5,
                              attrs: {
                                lazy: true,
                                name: "tabPrePlanBookingLcl",
                                label: _vm.$t("SeaExport.prePlanBooking")
                              }
                            },
                            [
                              _vm.commonInfo.showCombinedManifest
                                ? _c("tab-pre-plan-booking-jc", {
                                    ref: "tabPrePlanBookingLcl",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: {
                                      reload: _vm.reload,
                                      prePlanBookingToVgm:
                                        _vm.prePlanBookingToVgm,
                                      jobChangeState: _vm.onJobChangeState
                                    }
                                  })
                                : _c("tab-pre-plan-booking-jc", {
                                    ref: "tabPrePlanBookingLcl",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: {
                                      reload: _vm.reload,
                                      prePlanBookingToVgm:
                                        _vm.prePlanBookingToVgm
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      (_vm.masterFlag || _vm.paramsOfTab.signMBL) &&
                      _vm.privilege.seBooking.mbl
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 6,
                              attrs: {
                                lazy: true,
                                name: "tabMBL",
                                label: "MB/L"
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable && !_vm.isFba
                                ? _c("tab-mbl-UICustom", {
                                    ref: "tabMBL",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "view-source": "SeBooking"
                                    },
                                    on: {
                                      resetTab: _vm.resetTab,
                                      changeDataSFT: _vm.changeDataSFTFunc
                                    }
                                  })
                                : _c("tab-mbl", {
                                    ref: "tabMBL",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "view-source": "SeBooking"
                                    },
                                    on: {
                                      resetTab: _vm.resetTab,
                                      changeDataSFT: _vm.changeDataSFTFunc
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.privilege.seBooking.mbl2 &&
                      _vm.paramsOfTab.typeMBL !== 0 &&
                        _vm.paramsOfTab.typeMBL !== 1
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 7,
                              attrs: {
                                lazy: true,
                                name: "tabMBL2",
                                label:
                                  "MB/L" +
                                  (_vm.paramsOfTab.typeMBL === 2
                                    ? _vm.$t("CargoMsg.Cargo_SplitBL")
                                    : "") +
                                  (_vm.paramsOfTab.typeMBL === 3
                                    ? _vm.$t("SeaExport.MergeAndSingle")
                                    : "")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable && !_vm.isFba
                                ? _c("tab-mbl2-UICustom", {
                                    ref: "tabMBL2",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: { syncData: _vm.syncData }
                                  })
                                : _c("tab-mbl2", {
                                    ref: "tabMBL2",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: { syncData: _vm.syncData }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.paramsOfTab.signHBL &&
                      !_vm.paramsOfTab.mblOnly &&
                      (!_vm.masterFlag || _vm.isBuyerConsoleFcl) &&
                      _vm.privilege.seBooking.hbl
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 8,
                              attrs: {
                                lazy: true,
                                name: "tabHBL",
                                label: "HB/L"
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable && !_vm.isFba
                                ? _c("tab-hbl-UICustom", {
                                    ref: "tabHBL",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "view-source": "SeBooking"
                                    },
                                    on: {
                                      resetTab: _vm.resetTab,
                                      syncData: _vm.syncData,
                                      sinceSingle: _vm.sinceSingle
                                    }
                                  })
                                : _c("tab-hbl", {
                                    ref: "tabHBL",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "view-source": "SeBooking"
                                    },
                                    on: {
                                      resetTab: _vm.resetTab,
                                      syncData: _vm.syncData,
                                      sinceSingle: _vm.sinceSingle
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.paramsOfTab.mblOnly &&
                      !_vm.isNew &&
                      _vm.privilege.seBooking.hbl2 &&
                      _vm.paramsOfTab.typeHBL !== 0 &&
                        _vm.paramsOfTab.typeHBL !== 1
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 9,
                              attrs: {
                                lazy: true,
                                name: "tabHBL2",
                                label:
                                  "HB/L" +
                                  (_vm.paramsOfTab.typeHBL === 2
                                    ? _vm.$t("CargoMsg.Cargo_SplitBL")
                                    : "") +
                                  (_vm.paramsOfTab.typeHBL === 3
                                    ? _vm.$t("SeaExport.MergeAndSingle")
                                    : "")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable && !_vm.isFba
                                ? _c("tab-hbl2-UICustom", {
                                    ref: "tabHBL2",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: { syncData: _vm.syncData }
                                  })
                                : _c("tab-hbl2", {
                                    ref: "tabHBL2",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: { syncData: _vm.syncData }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.paramsOfTab.ams &&
                      _vm.privilege.seBooking.ams
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 10,
                              attrs: {
                                lazy: true,
                                name: "tabAMS",
                                label: _vm.$t(
                                  "SeaExport.Anti_terrorismShipping"
                                )
                              }
                            },
                            [
                              _c("tab-ams", {
                                ref: "tabAMS",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.paramsOfTab.virtualHBL &&
                      _vm.privilege.seBooking.tabSubBill
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 11,
                              attrs: {
                                lazy: true,
                                name: "tabSubBill",
                                label: _vm.$t("SeaExport.FormalHbl")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable && !_vm.isFba
                                ? _c("tab-sub-bill-UICustom", {
                                    ref: "tabSubBill",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: { syncData: _vm.syncData }
                                  })
                                : _c("tab-sub-bill", {
                                    ref: "tabSubBill",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: { syncData: _vm.syncData }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.masterFlag &&
                      _vm.privilege.seBooking.containersLayer
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 12,
                              attrs: {
                                lazy: true,
                                name: "tabContainer",
                                label: _vm.$t("SeaExport.ContainerInfo")
                              }
                            },
                            [
                              _c("tab-container", {
                                ref: "tabContainer",
                                attrs: {
                                  "slave-customs-declaration-enable":
                                    _vm.slaveCustomsDeclarationEnable,
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  "enable-ui-custom":
                                    _vm.$store.state.uiCustom.enable &&
                                    !_vm.isFba
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.masterFlag &&
                      !_vm.isNew &&
                      _vm.privilege.seBooking.lclManagerLayer &&
                      !_vm.isBuyerConsoleFcl
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 13,
                              attrs: {
                                lazy: true,
                                name: "tabLclContainer",
                                label: _vm.$t("SeaExport.ContainerInfo")
                              }
                            },
                            [
                              _vm.masterCustomsDeclarationEnable
                                ? _c("tab-lcl-container-multi-so-no-mode", {
                                    ref: "tabLclContainer",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      location: _vm.location,
                                      "enable-ui-custom":
                                        _vm.$store.state.uiCustom.enable &&
                                        !_vm.isFba
                                    },
                                    on: {
                                      addSlavedJob: _vm.addSlavedJob,
                                      removeJobFromMaster:
                                        _vm.removeJobFromMaster,
                                      split: _vm.splitHandle
                                    }
                                  })
                                : _c("tab-lcl-container", {
                                    ref: "tabLclContainer",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      location: _vm.location,
                                      "enable-ui-custom":
                                        _vm.$store.state.uiCustom.enable &&
                                        !_vm.isFba
                                    },
                                    on: {
                                      addSlavedJob: _vm.addSlavedJob,
                                      removeJobFromMaster:
                                        _vm.removeJobFromMaster,
                                      split: _vm.splitHandle
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.masterFlag &&
                      !_vm.isNew &&
                      _vm.privilege.seBooking.lclManagerLayer &&
                      _vm.isBuyerConsoleFcl
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 29,
                              attrs: {
                                lazy: true,
                                name: "tabBuyerConsoleFclContainer",
                                label: _vm.$t("SeaExport.ContainerInfo")
                              }
                            },
                            [
                              _c("tab-buyer-console-fcl-container", {
                                ref: "tabBuyerConsoleFclContainer",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  "enable-ui-custom":
                                    _vm.$store.state.uiCustom.enable &&
                                    !_vm.isFba
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) && _vm.paramsOfTab.vgm
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 14,
                              attrs: {
                                lazy: true,
                                name: "tabVGM",
                                label: "VGM"
                              }
                            },
                            [
                              _c("tab-vgm", {
                                ref: "tabVGM",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.paramsOfTab.backUpWarehouse &&
                      _vm.privilege.seBooking.backUpWarehouseTab
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 29,
                              attrs: {
                                lazy: true,
                                name: "tabBackUpWarehouse",
                                label: _vm.$t("SeaExport.BackUpWarehouse")
                              }
                            },
                            [
                              _c("tab-back-up-warehouse", {
                                ref: "tabBackUpWarehouse",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.paramsOfTab.warehousing &&
                      _vm.privilege.seBooking.warehouseTab
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 15,
                              attrs: {
                                lazy: true,
                                name: "tabWarehouse",
                                label: _vm.$t("SeaExport.WarehouseLoading")
                              }
                            },
                            [
                              _c("tab-warehouse", {
                                ref: "tabWarehouse",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditWarehouse
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isNew &&
                      _vm.isFba &&
                      !_vm.masterFlag &&
                      _vm.paramsOfTab.warehousing &&
                      _vm.$checkPermission([
                        "tab_FBABookingNew_fbaSeaWarehouseTab"
                      ])
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 29,
                              attrs: {
                                label: _vm.$t("SeaExport.DomesticWarehouse"),
                                lazy: true,
                                name: "fbaWarehousingDetail"
                              }
                            },
                            [
                              _c("fba-warehousing-detail", {
                                ref: "fbaWarehousingDetail",
                                attrs: {
                                  lob: "FBA",
                                  action: _vm.action,
                                  source: "fbaSea",
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isNew &&
                      _vm.isFba &&
                      !_vm.masterFlag &&
                      _vm.$checkPermission([
                        "tab_FBABookingNew_fbaSeaoverSeaWarehouseTab"
                      ])
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 30,
                              attrs: {
                                label: _vm.$t("SeaExport.ForeignWarehouse"),
                                lazy: true,
                                name: "fbaOutWarehouse"
                              }
                            },
                            [
                              _c("fba-out-warehouse", {
                                ref: "fbaOutWarehouse",
                                attrs: {
                                  action: _vm.action,
                                  context: _vm.context,
                                  source: "fbaSea",
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.paramsOfTab.landTransportation &&
                      _vm.privilege.seBooking.seTruckingPage
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 16,
                              attrs: {
                                lazy: true,
                                name: "tabTruckingForSe",
                                label: _vm.$t("SeaExport.Trucking")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable && !_vm.isFba
                                ? _c("tab-trucking-UICustom", {
                                    ref: "tabTruckingForSe",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit":
                                        _vm.cooperateEditTrucking
                                    }
                                  })
                                : _c("tab-trucking-for-se", {
                                    ref: "tabTruckingForSe",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit":
                                        _vm.cooperateEditTrucking
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.dischargingPortDoor &&
                      _vm.privilege.seBooking.seDischargingTrukingPage
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "tabDischargingTrucking",
                              attrs: {
                                lazy: true,
                                name: "tabDischargingTrucking",
                                label: _vm.$t(
                                  "SeaExport.DispatchVehiclesAtDestination"
                                )
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable && !_vm.isFba
                                ? _c("tab-discharging-trucking-UICustom", {
                                    ref: "tabDischargingTrucking",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "show-sync":
                                        _vm.btnInfo
                                          .btnEntrustmentSISynchronized,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    }
                                  })
                                : _c("tab-discharging-trucking", {
                                    ref: "tabDischargingTrucking",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "show-sync":
                                        _vm.btnInfo
                                          .btnEntrustmentSISynchronized,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.destPortCustomsClearance &&
                      _vm.privilege.seBooking.seDischargingTrukingPage
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "tabDestinationCustomsData",
                              attrs: {
                                lazy: true,
                                name: "tabDestinationCustomsData",
                                label: _vm.$t(
                                  "SeaExport.PortOfDestinationCustomsClearance"
                                )
                              }
                            },
                            [
                              _c("tab-destination-customs-data", {
                                ref: "tabDestinationCustomsData",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "force-readonly":
                                    _vm.source !== "endCommerce",
                                  "consign-readonly":
                                    _vm.source === "endCommerce" &&
                                    _vm.action === "edit",
                                  "customs-section-readonly": !(
                                    _vm.source === "endCommerce" &&
                                    _vm.action === "edit"
                                  ),
                                  "show-copy-consign-btn":
                                    _vm.source === "endCommerce"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      (!_vm.isFba
                      ? _vm.showTabWarehouseIn
                      : _vm.showTabWarehouseIn && _vm.masterFlag)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 17,
                              attrs: {
                                lazy: true,
                                name: "tabWarehouseIn",
                                label: _vm.$t("SeaExport.CargoInfo")
                              }
                            },
                            [
                              _c("tab-warehouse-in", {
                                ref: "tabWarehouseIn",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { refreshTabs: _vm.refresh }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.paramsOfTab.customs &&
                      _vm.privilege.seBooking.seCustomsInfo
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 18,
                              attrs: {
                                lazy: true,
                                name: "tabCustomsInfo",
                                label: _vm.$t("SeaExport.CustomsDeclaration")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable && !_vm.isFba
                                ? _c("tab-customs-info-UICustom", {
                                    ref: "tabCustomsInfo",
                                    attrs: {
                                      "slave-customs-declaration-enable":
                                        _vm.slaveCustomsDeclarationEnable,
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditCustoms
                                    }
                                  })
                                : _c("tab-customs-info", {
                                    ref: "tabCustomsInfo",
                                    attrs: {
                                      "slave-customs-declaration-enable":
                                        _vm.slaveCustomsDeclarationEnable,
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditCustoms
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) && _vm.paramsOfTab.insure
                        ? _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                lazy: true,
                                name: "tabInsure",
                                label: _vm.$t("SeaExport.InsureInfo")
                              }
                            },
                            [
                              _c("tab-insure", {
                                ref: "tabInsure",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.privilege.charge.chargeView &&
                      !_vm.isFba
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 19,
                              attrs: {
                                lazy: true,
                                name: "tabTradeDetail",
                                label: _vm.$t("SeaExport.TradeDetail")
                              }
                            },
                            [
                              !_vm.commonInfo.poItemsTabViewModel
                                ? _c("tab-trade-detail", {
                                    ref: "tabTradeDetail",
                                    attrs: {
                                      "slave-customs-declaration-enable":
                                        _vm.slaveCustomsDeclarationEnable,
                                      "is-uppercase-by-config":
                                        _vm.isUppercaseByConfig,
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    },
                                    on: { syncData: _vm.syncData }
                                  })
                                : _vm._e(),
                              _vm.commonInfo.poItemsTabViewModel
                                ? _c("tab-po-items-upgrade", {
                                    ref: "tabTradeDetail",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isNew &&
                      _vm.isFba &&
                      !_vm.masterFlag &&
                      _vm.$checkPermission([
                        "tab_FBABookingNew_fbaSeaGoodsDetailTab"
                      ])
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 31,
                              attrs: {
                                label: _vm.$t("SeaExport.TradeDetail"),
                                lazy: true,
                                name: "fbaGoodsDetail"
                              }
                            },
                            [
                              _c("tab-warehousing-detail", {
                                ref: "fbaGoodsDetail",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  source: "fbaSea",
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  "is-uppercase-by-config":
                                    _vm.isUppercaseByConfig
                                },
                                on: { reload: _vm.reload }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.paramsOfTab.itmService
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 20,
                              attrs: {
                                lazy: true,
                                name: "tabTradeCommission",
                                label: _vm.$t("SeaExport.TradeCommission")
                              }
                            },
                            [
                              _c("tab-trade-commission", {
                                ref: "tabTradeCommission",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.privilege.charge.chargeView
                        ? [
                            !_vm.chargePageSet.hideTabCharge
                              ? _c(
                                  "el-tab-pane",
                                  {
                                    key: 21,
                                    attrs: {
                                      lazy: true,
                                      name: "tabCharges",
                                      label: _vm.$t("SeaExport.Charge")
                                    }
                                  },
                                  [
                                    _c("tab-charges", {
                                      ref: "tabCharges",
                                      attrs: {
                                        context: _vm.context,
                                        action: _vm.action,
                                        "is-cross-tenant-se-to-si":
                                          _vm.isCrossTenantSEToSIStatus,
                                        location: _vm.location,
                                        "view-source": "SeBooking",
                                        "enable-ui-custom": true,
                                        "provision-lock":
                                          _vm.commonInfo.provisionLock
                                      },
                                      on: {
                                        ChargeLockStatusChange:
                                          _vm.chargeLockStatusChange
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.chargePageSet.arAloneShow &&
                            _vm.privilege.charge.chargeReceivable
                              ? _c(
                                  "el-tab-pane",
                                  {
                                    key: "chargeArTab",
                                    attrs: {
                                      lazy: true,
                                      name: "tabChargesAr",
                                      label: _vm.$t("queryJob.FeeReceivable")
                                    }
                                  },
                                  [
                                    _c("tab-charges", {
                                      ref: "tabChargesAr",
                                      attrs: {
                                        context: _vm.context,
                                        action: _vm.action,
                                        "is-cross-tenant-se-to-si":
                                          _vm.isCrossTenantSEToSIStatus,
                                        location: _vm.location,
                                        "view-source": "SeBooking",
                                        "tab-name": "tabChargesAr",
                                        type: "ar",
                                        "enable-ui-custom": true,
                                        "provision-lock":
                                          _vm.commonInfo.provisionLock
                                      },
                                      on: {
                                        ChargeLockStatusChange:
                                          _vm.chargeLockStatusChange
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.chargePageSet.apAloneShow &&
                            _vm.privilege.charge.chargePayable
                              ? _c(
                                  "el-tab-pane",
                                  {
                                    key: "chargeApTab",
                                    attrs: {
                                      lazy: true,
                                      name: "tabChargesAp",
                                      label: _vm.$t("queryJob.CostsPayable")
                                    }
                                  },
                                  [
                                    _c("tab-charges", {
                                      ref: "tabChargesAp",
                                      attrs: {
                                        context: _vm.context,
                                        action: _vm.action,
                                        "is-cross-tenant-se-to-si":
                                          _vm.isCrossTenantSEToSIStatus,
                                        location: _vm.location,
                                        "view-source": "SeBooking",
                                        "tab-name": "tabChargesAp",
                                        type: "ap",
                                        "enable-ui-custom": true,
                                        "provision-lock":
                                          _vm.commonInfo.provisionLock
                                      },
                                      on: {
                                        ChargeLockStatusChange:
                                          _vm.chargeLockStatusChange
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.privilege.chargeConfirm.chargeConfirmView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 22,
                              attrs: {
                                lazy: true,
                                name: "tabInternalBill",
                                label: _vm.$t("SeaExport.InternalBillInfo")
                              }
                            },
                            [
                              _c("tab-internal-bill", {
                                ref: "tabInternalBill",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  location: _vm.location,
                                  "enable-ui-custom":
                                    _vm.$store.state.uiCustom.enable &&
                                    !_vm.isFba,
                                  "page-type":
                                    _vm.UICustomConstants
                                      .SEA_BOOKING_DOMESTIC_BILLING
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.privilege.billTab.billTabView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 23,
                              attrs: {
                                lazy: true,
                                name: "tabOverseaBill",
                                label: _vm.$t("SeaExport.OverseaBillInfo")
                              }
                            },
                            [
                              _c("tab-oversea-bill", {
                                ref: "tabOverseaBill",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  location: _vm.location,
                                  "view-source": "SeaBooking",
                                  "enable-ui-custom":
                                    _vm.$store.state.uiCustom.enable &&
                                    !_vm.isFba,
                                  "page-type":
                                    _vm.UICustomConstants
                                      .SEA_BOOKING_OVERSEA_BILL
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.privilege.charge.advanceCharge
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 24,
                              attrs: {
                                lazy: true,
                                name: "tabAdvanceCharge",
                                label: _vm.$t("SeaExport.AdvanceChargeInfo")
                              }
                            },
                            [
                              _c("tab-advance-charge", {
                                ref: "tabAdvanceCharge",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  location: _vm.location
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.privilege.seBooking.fileTab
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 25,
                              attrs: {
                                lazy: true,
                                name: "tabFile",
                                label: _vm.$t("SeaExport.DocumentCirculation")
                              }
                            },
                            [
                              _c("tab-file", {
                                ref: "tabFile",
                                attrs: {
                                  context: _vm.context,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.masterFlag &&
                      _vm.paramsOfTab.cargoType &&
                      _vm.paramsOfTab.cargoType !== "GC" &&
                      _vm.privilege.seBooking.specialGoodsTab
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 26,
                              attrs: {
                                lazy: true,
                                name: "tabSpecialGoods",
                                label: _vm.$t("SpecialGoods.label")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable && !_vm.isFba
                                ? _c("tab-special-goods-UICustom", {
                                    ref: "tabSpecialGoods",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    }
                                  })
                                : _c("tab-special-goods", {
                                    ref: "tabSpecialGoods",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.privilege.seBooking.portalState &&
                      !_vm.isNew
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 27,
                              attrs: {
                                lazy: true,
                                name: "tabSopState",
                                label: _vm.$t("SeaExport.BusinessStatus")
                              }
                            },
                            [
                              _c("tab-sop-state", {
                                ref: "tabSopState",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "is-cross-tenant-se-to-si":
                                    _vm.isLoadRelatedSop,
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  "controlled-locked": _vm.controlledLocked,
                                  "sop-template-config": _vm.sopTemplateConfig
                                },
                                on: {
                                  refresh: function($event) {
                                    return _vm.$emit(
                                      "refreshList",
                                      _vm.job.jobNo
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.privilege.fileHistory.fileHistoryView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 28,
                              attrs: {
                                lazy: true,
                                name: "tabFileHistory",
                                label: _vm.$t("SeaExport.FileHistory")
                              }
                            },
                            [
                              _c("tab-file-history", {
                                ref: "tabFileHistory",
                                attrs: {
                                  context: _vm.context,
                                  "btn-info": _vm.btnInfo,
                                  "is-cross-tenant-se-to-si":
                                    _vm.isCrossTenantSEToSIStatus,
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  "controlled-locked": _vm.controlledLocked,
                                  "preview-file-method": function(p) {
                                    return _vm.previewFileMethod(p)
                                  },
                                  "can-operate-job": _vm.canOperateJob,
                                  "view-source": "SeBooking",
                                  "show-instruction": true
                                },
                                on: { writebackJob: _vm.writebackJob }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c("cargo-template-selector-dialog", {
        ref: "templateSelectorDialog",
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: _vm.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.checkingWindow.visible
        ? _c("checking-window", {
            attrs: {
              visible: _vm.checkingWindow.visible,
              lob: _vm.lob,
              job: _vm.job,
              "check-node": _vm.checkingWindow.checkNode,
              "call-back": _vm.checkingWindow.callBack,
              "call-back2": _vm.checkingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("estimate-validation-dialog", {
        ref: "estimateValidationDialog",
        attrs: {
          visible: _vm.estimateValidationDialog.visible,
          job: _vm.estimateValidationDialog.job,
          "estimate-profit-rate":
            _vm.estimateValidationDialog.estimateProfitRate,
          "tatol-profit": _vm.estimateValidationDialog.tatolProfit
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.estimateValidationDialog, "visible", $event)
          },
          callback: _vm.estimateValidationDialog.callback
        }
      }),
      _vm.shutOutDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.shutOutDialog.visible,
                title: _vm.$t("Message.Warning"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.shutOutDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "padding-left": "30px"
                  }
                },
                [
                  _c("span", { staticStyle: { "line-height": "40px" } }, [
                    _vm._v(_vm._s(_vm.$t("Message.PleaseConfirmTheShutOut")))
                  ]),
                  _c("span", { staticStyle: { "line-height": "18px" } }, [
                    _vm._v(_vm._s(_vm.shutOutDialog.shutOutTip1))
                  ]),
                  _c("span", { staticStyle: { "line-height": "18px" } }, [
                    _vm._v(_vm._s(_vm.shutOutDialog.shutOutTip2))
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.hasChargeShutoutHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.HasChargeToShutOut")))]
                  ),
                  _c(
                    "el-button",
                    {
                      style: { display: _vm.shutOutDialog.shutOutButtonShow2 },
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.noHasChargeShutoutHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.NoChargeToShutOut")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.shutOutDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.dataPushDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "app-main-inner",
              attrs: {
                visible: _vm.dataPushDialog.visible,
                title: _vm.$t("SeaExport.DataPushChangeLog"),
                width: "680px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.dataPushDialog, "visible", $event)
                },
                close: function($event) {
                  _vm.dataPushDialog.visible = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: {
                    padding: "0",
                    display: "flex",
                    "flex-direction": "column"
                  },
                  style: { width: "100%", height: "400px", overflow: "auto" }
                },
                _vm._l(_vm.dataPushDialog.titles, function(title, index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c("div", { staticStyle: { background: "#EBECF5" } }, [
                        _c("b", [_vm._v(_vm._s(title))])
                      ]),
                      _vm._l(_vm.dataPushDialog.dataMap.get(title), function(
                        item,
                        index
                      ) {
                        return _c("div", { key: index }, [
                          _c(
                            "div",
                            {
                              class: {
                                "set-style": item.includes("箱号："),
                                "set-mgTop": item.includes("箱号：") && index
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  item.includes("箱号：containerNoNull")
                                    ? ""
                                    : item
                                )
                              )
                            ]
                          )
                        ])
                      })
                    ],
                    2
                  )
                }),
                0
              )
            ]
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.returnDialog.visible,
            title: "温馨提示",
            width: "480px",
            "close-on-click-modal": false,
            "before-close": function() {
              _vm.returnDialog.visible = false
            }
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.returnDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "0 20px" } },
            [
              _c(
                "div",
                {
                  staticStyle: { "font-size": "16px", "margin-bottom": "20px" }
                },
                [_vm._v("确定退回后重新提交吗？")]
              ),
              _c(
                "el-form",
                {
                  attrs: { "label-width": "110px", "label-position": "right" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择退回的模块" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.returnDialog.module,
                            callback: function($$v) {
                              _vm.$set(_vm.returnDialog, "module", $$v)
                            },
                            expression: "returnDialog.module"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "海运订舱", value: "SEA_BOOKING" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "退回原因" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          placeholder: "请输入退回原因",
                          maxlength: "500",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.returnDialog.reason,
                          callback: function($$v) {
                            _vm.$set(_vm.returnDialog, "reason", $$v)
                          },
                          expression: "returnDialog.reason"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.returnDialog.visible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.toConfirmReturn }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      ),
      _c("business-status-log-dialog", {
        attrs: {
          visible: _vm.businessStatusDialog.visible,
          "job-uuid": _vm.job.uuid || ""
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.businessStatusDialog, "visible", $event)
          }
        }
      }),
      _vm.ediStatusLogDialog.visible
        ? _c("edi-status-log-dialog", {
            attrs: {
              visible: _vm.ediStatusLogDialog.visible,
              "job-uuid": _vm.job.uuid || ""
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.ediStatusLogDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.bookingSpaceLogDialog.visible
        ? _c("booking-space-log-dialog", {
            attrs: {
              visible: _vm.bookingSpaceLogDialog.visible,
              "job-uuid": _vm.job.uuid || ""
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.bookingSpaceLogDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.pushResultLogDialog.visible
        ? _c("push-result-log-dialog", {
            attrs: {
              visible: _vm.pushResultLogDialog.visible,
              "job-uuid": _vm.job.uuid || ""
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.pushResultLogDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("sop-state-dialog", {
        attrs: {
          "hide-window": _vm.isEditing,
          visible: _vm.sopStateDialog.visible,
          "is-need-refresh": _vm.sopStateDialog.isNeedRefresh,
          "default-is-expand": _vm.sopStateDialog.defaultIsExpand,
          job: _vm.job,
          "is-need-expand": _vm.sopStateDialog.isNeedExpand
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.sopStateDialog, "visible", $event)
          },
          "update:isNeedExpand": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedExpand", $event)
          },
          "update:is-need-expand": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedExpand", $event)
          },
          handleClose: _vm.sopStateDialogClose
        }
      }),
      _vm.sendBranchWindow.visible
        ? [
            _vm.sendBranchSelectObject === 2
              ? _c(
                  "el-dialog",
                  {
                    directives: [
                      { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                    ],
                    attrs: {
                      visible: _vm.sendBranchWindow.visible,
                      title: _vm.$t("SeaExport.ConsignationSI"),
                      width: "550px",
                      "close-on-click-modal": false
                    },
                    on: {
                      "update:visible": function($event) {
                        return _vm.$set(_vm.sendBranchWindow, "visible", $event)
                      }
                    }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-width": "96px",
                          "label-position": "right"
                        }
                      },
                      [
                        _c("el-form-item", { attrs: { "label-width": "0" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#000000",
                                "font-size": "14px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_EntrustedReceiveInfo")
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._l(_vm.sendBranchWindow.items, function(
                          item,
                          index
                        ) {
                          return _c(
                            "el-form-item",
                            {
                              key: index,
                              attrs: {
                                label:
                                  item.selectObject === 0
                                    ? _vm.$t("SeaExport.CustomerService")
                                    : _vm.$t("SeaExport.Operation")
                              }
                            },
                            [
                              _c("cargo-user-select", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  "method-params": {
                                    officeId:
                                      _vm.sendBranchWindow.office.officeId,
                                    category: "role",
                                    shape:
                                      item.selectObject === 0 ? "csr" : "op"
                                  }
                                },
                                on: {
                                  change: function(p) {
                                    item.userId = p.value
                                    _vm.userId_changeHandler(item)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        _vm.enableEntrustmentSI
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.CustomJobType")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    "select-type":
                                      _vm.selectTypeNames
                                        .basic_data_CutomJobType,
                                    filterable: "",
                                    "method-params": {
                                      type: "SI",
                                      grade: 0,
                                      active: true
                                    },
                                    "tag-name": _vm.isZh
                                      ? "name"
                                      : "englishName"
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.sendBranchWindow.customJobType =
                                        p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      2
                    ),
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-width": "40px",
                          inline: true,
                          "label-position": "right"
                        }
                      },
                      [
                        _c("el-form-item", { attrs: { label: " " } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "200px",
                                color: "#000000",
                                "font-size": "14px",
                                "text-align": "center"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$store.getters.currentOffice.chineseName
                                )
                              )
                            ]
                          )
                        ]),
                        _c("el-form-item", { attrs: { label: " " } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "200px",
                                color: "#000000",
                                "font-size": "14px",
                                "text-align": "center"
                              }
                            },
                            [_vm._v(_vm._s(_vm.sendBranchWindow.title))]
                          )
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { label: " " } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                attrs: { value: "consignee", disabled: "" }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("Message.Consignee"),
                                    value: "consignee"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { "label-width": "44px" } },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: { color: "rgb(153, 153, 153)" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v("———")]
                            ),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                on: { change: _vm.onConsigneeTargetChange },
                                model: {
                                  value: _vm.sendBranchWindow.consigneeTarget,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.sendBranchWindow,
                                      "consigneeTarget",
                                      $$v
                                    )
                                  },
                                  expression: "sendBranchWindow.consigneeTarget"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("Message.Consignee"),
                                    value: "consignee"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.ConsignationCompany"
                                    ),
                                    value: "customer"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: " " } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  value: "consigneeDetail",
                                  disabled: ""
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("SeaExport.ConsigneeDetail"),
                                    value: "consigneeDetail"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { "label-width": "44px" } },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: { color: "rgb(153, 153, 153)" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v("———")]
                            ),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "200px" },
                                on: {
                                  change: _vm.onConsigneeDetailTargetChange
                                },
                                model: {
                                  value:
                                    _vm.sendBranchWindow.consigneeDetailTarget,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.sendBranchWindow,
                                      "consigneeDetailTarget",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "sendBranchWindow.consigneeDetailTarget"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("SeaExport.ConsigneeDetail"),
                                    value: "consigneeDetail"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("SeaExport.ShipperDetail"),
                                    value: "shipperDetail"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-top": "20px",
                          "margin-left": "40px"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("queryJob.NoteConsigneeCustomerExportImport")
                          )
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        },
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { color: "#000000" },
                            on: { change: _vm.onCheckConsigneeDefaultChange },
                            model: {
                              value: _vm.sendBranchWindow.checkConsigneeDefault,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.sendBranchWindow,
                                  "checkConsigneeDefault",
                                  $$v
                                )
                              },
                              expression:
                                "sendBranchWindow.checkConsigneeDefault"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("queryJob.SetAsDefaultExportInfo"))
                            )
                          ]
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.enterSendHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                            ),
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.sendBranchWindow.visible = false
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c(
                  "el-dialog",
                  {
                    directives: [
                      { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
                    ],
                    attrs: {
                      visible: _vm.sendBranchWindow.visible,
                      title: _vm.sendBranchWindow.title,
                      width: "360px",
                      "close-on-click-modal": false
                    },
                    on: {
                      "update:visible": function($event) {
                        return _vm.$set(_vm.sendBranchWindow, "visible", $event)
                      }
                    }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-width": "96px",
                          "label-position": "right"
                        }
                      },
                      [
                        _vm._l(_vm.sendBranchWindow.items, function(
                          item,
                          index
                        ) {
                          return _c(
                            "el-form-item",
                            {
                              key: index,
                              attrs: {
                                label:
                                  item.selectObject === 0
                                    ? _vm.$t("SeaExport.CustomerService")
                                    : item.selectObject === 1
                                    ? _vm.$t("SeaExport.Operation")
                                    : _vm.$t("SeaExport.Planner")
                              }
                            },
                            [
                              _c("cargo-user-select", {
                                attrs: {
                                  "method-params": {
                                    officeId:
                                      _vm.sendBranchWindow.office.officeId,
                                    category: "role",
                                    shape:
                                      item.selectObject === 0
                                        ? "csr"
                                        : item.selectObject === 1
                                        ? "op"
                                        : "sealine"
                                  }
                                },
                                on: {
                                  change: function(p) {
                                    item.userId = p.value
                                    _vm.userId_changeHandler(item)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        _vm.enableEntrustmentSI
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.CustomJobType")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    "select-type":
                                      _vm.selectTypeNames
                                        .basic_data_CutomJobType,
                                    filterable: "",
                                    "method-params": {
                                      type: "SI",
                                      grade: 0,
                                      active: true
                                    },
                                    "tag-name": _vm.isZh
                                      ? "name"
                                      : "englishName"
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.sendBranchWindow.customJobType =
                                        p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.showdCheckSalesMapping
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("queryJob.SalesMapping")
                                }
                              },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: { no: "checkSalesMapping" },
                                    model: {
                                      value:
                                        _vm.sendBranchWindow.checkSalesMapping,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.sendBranchWindow,
                                          "checkSalesMapping",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "sendBranchWindow.checkSalesMapping"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("queryJob.SalesCargoSalesMap")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      2
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: { margin: "0 auto", width: "fit-content" },
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.enterSendHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                        ),
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                _vm.sendBranchWindow.visible = false
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
          ]
        : _vm._e(),
      _vm.trustFromWindow.visible
        ? _c("trust-from-window", {
            ref: "trustFromWindow",
            attrs: {
              visible: _vm.trustFromWindow.visible,
              "trust-job": _vm.trustFromWindow.trustJob,
              job: _vm.trustFromWindow.job,
              context: _vm.context,
              "can-operate-job": _vm.canOperateJob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.trustFromWindow, "visible", $event)
              },
              refresh: _vm.applyCloseAndRefresh
            }
          })
        : _vm._e(),
      _vm.crossTenantDialog.visible
        ? _c("cross-tenant-change-history-dialog", {
            attrs: {
              data: _vm.crossTenantDialog.data,
              "has-un-read": _vm.crossTenantDialog.readState,
              visible: _vm.crossTenantDialog.visible,
              "job-uuid": _vm.job.uuid,
              lob: _vm.job.lob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.crossTenantDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.pushLogDialog.visible
        ? _c("push-log-dialog", {
            attrs: {
              visible: _vm.pushLogDialog.visible,
              "job-uuid": _vm.job.uuid || ""
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.pushLogDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.checkingSaveJobWindow.visible
        ? _c("checking-save-job-window", {
            attrs: {
              visible: _vm.checkingSaveJobWindow.visible,
              lob: "SE",
              "row-data": _vm.checkingSaveJobWindow.rowData,
              "check-node": _vm.checkingSaveJobWindow.checkNode,
              "call-back": _vm.checkingSaveJobWindow.callBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingSaveJobWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.relatedSiFromWindow.visible
        ? _c("related-si-from-window", {
            ref: "relatedSiFromWindow",
            attrs: {
              visible: _vm.relatedSiFromWindow.visible,
              "related-job": _vm.relatedSiFromWindow.relatedJob,
              context: _vm.context,
              "can-operate-job": _vm.canOperateJob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.relatedSiFromWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.cooperationBranchListDialog.visible
        ? _c("cooperation-branch-list", {
            attrs: {
              visible: _vm.cooperationBranchListDialog.visible,
              "job-uuid": _vm.cooperationBranchListDialog.jobUuid,
              job: _vm.cooperationBranchListDialog.job,
              "order-center-branch":
                _vm.cooperationBranchListDialog.orderCenterBranch
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.cooperationBranchListDialog,
                  "visible",
                  $event
                )
              },
              refresh: function(cooperatebranch) {
                _vm.updateJobCooperate(cooperatebranch)
                _vm.refreshChargeTabCooperatebranch(cooperatebranch)
              },
              cancel: function() {
                return (_vm.cooperationBranchListDialog.visible = false)
              },
              refreshJob: _vm.reload
            }
          })
        : _vm._e(),
      _vm.jobApplyDialog.visible
        ? _c("job-apply-dialog", {
            attrs: {
              visible: _vm.jobApplyDialog.visible,
              title: _vm.$t("CargoMsg.Cargo_SubmitJobChargeForApproval"),
              type: "apply",
              "doc-id": _vm.job.uuid,
              "document-config-id": _vm.documentConfigId
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.jobApplyDialog, "visible", $event)
              },
              close: function($event) {
                _vm.jobApplyDialog.visible = false
              },
              closeAndRefresh: _vm.applyCloseAndRefresh
            }
          })
        : _vm._e(),
      _c("import-order-dialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.importOrderDialog.visible,
            expression: "importOrderDialog.visible"
          }
        ],
        ref: "importOrderDialog",
        attrs: {
          visible: _vm.importOrderDialog.visible,
          lob: _vm.importOrderDialog.job.lob || "SE",
          job: _vm.importOrderDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.importOrderDialog, "visible", $event)
          },
          confirmCallBack: function(data) {
            _vm.importOrderConfirmCallBack(data)
          }
        }
      }),
      _vm.previewFileData.visible
        ? _c(
            "cargo-dialog",
            {
              attrs: {
                no: "preview",
                title: _vm.$t("FileHistory.preview"),
                visible: _vm.previewFileData.visible,
                "can-maximize": true,
                "can-minimize": true,
                "custom-class": "preview-dialog"
              },
              on: {
                close: _vm.closePreviewDialog,
                modalMin: _vm.onPreviewFileDailogMin
              }
            },
            [
              _vm.previewFileData.pdfSrc
                ? _c(
                    "div",
                    { staticClass: "pdf-img" },
                    [
                      _c(
                        "el-scrollbar",
                        _vm._l(_vm.previewFileData.numPages, function(i) {
                          return _c("pdf", {
                            key: i,
                            attrs: { src: _vm.previewFileData.pdfSrc, page: i }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm.previewFileData.photoList.length > 0
                ? _c(
                    "viewer",
                    {
                      staticClass: "preview-img",
                      attrs: { images: _vm.previewFileData.photoList }
                    },
                    _vm._l(_vm.previewFileData.photoList, function(
                      item,
                      index
                    ) {
                      return _c("img", { key: index, attrs: { src: item } })
                    }),
                    0
                  )
                : _vm.previewFileData.officeFileUrl
                ? _c("iframe", {
                    staticClass: "office-preview",
                    attrs: { src: _vm.previewFileData.officeFileUrl }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.previewFileData.showViewBtn
        ? _c(
            "el-button",
            {
              staticStyle: {
                position: "absolute",
                right: "60px",
                bottom: "100px"
              },
              attrs: { no: "FileView", type: "primary" },
              on: { click: _vm.toViewFile }
            },
            [_vm._v(_vm._s(_vm.$t("Message.FileView")))]
          )
        : _vm._e(),
      _c("data-update-log-dialog", {
        attrs: {
          "hide-window": _vm.isEditing,
          visible: _vm.dataUpdateLogDialog.visible,
          "is-need-refresh": _vm.dataUpdateLogDialog.isNeedRefresh,
          "default-is-expand": _vm.dataUpdateLogDialog.defaultIsExpand,
          job: _vm.job,
          "is-need-expand": _vm.dataUpdateLogDialog.isNeedExpand
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.dataUpdateLogDialog, "visible", $event)
          },
          "update:isNeedExpand": function($event) {
            return _vm.$set(_vm.dataUpdateLogDialog, "isNeedExpand", $event)
          },
          "update:is-need-expand": function($event) {
            return _vm.$set(_vm.dataUpdateLogDialog, "isNeedExpand", $event)
          },
          handleClose: _vm.dataUpdateLogDialogClose
        }
      }),
      _c("jy-warehouse-api-log-dialog", {
        attrs: {
          visible: _vm.jyWarehouseApiLogDialog.visible,
          "job-uuid": _vm.job.uuid
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jyWarehouseApiLogDialog, "visible", $event)
          }
        }
      }),
      _c("msd-api-log-dialog", {
        attrs: {
          visible: _vm.msdApiLogDialog.visible,
          "job-uuid": _vm.job.uuid
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.msdApiLogDialog, "visible", $event)
          }
        }
      }),
      _c("job-return-review-dialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.returnReviewDialog.visible,
            expression: "returnReviewDialog.visible"
          }
        ],
        attrs: {
          visible: _vm.returnReviewDialog.visible,
          lob: "SE",
          "selected-jobs": _vm.returnReviewDialog.selectedJobs,
          srouce: "detail"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.returnReviewDialog, "visible", $event)
          },
          confirm: _vm.reload
        }
      }),
      _vm.ydBookingResultDialog.visible
        ? _c("yd-booking-result-dialog", {
            ref: "ydBookingResultDialog",
            attrs: {
              visible: _vm.ydBookingResultDialog.visible,
              "job-uuid": _vm.ydBookingResultDialog.jobUuid,
              job: _vm.ydBookingResultDialog.job,
              "yd-booking-result": _vm.ydBookingResultDialog.bookingResult
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.ydBookingResultDialog, "visible", $event)
              },
              close: _vm.closeYdBookingDialog,
              refreshJob: _vm.reload
            }
          })
        : _vm._e(),
      _c("custom-form-window", {
        ref: "customFormWindow",
        on: { instructionCallback: _vm.onInstructionCallback }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }